import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 space-y-6" data-testid="about-page">
      <h1 className="text-2xl font-bold text-[#FF0000] tracking-wider font-mono">About</h1>

      <Card className="sg-frame border-[#FF0000]/20">
        <CardHeader>
          <CardTitle className="text-[#FF0000]">Vince Sinnott</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-[#ddd] text-sm leading-relaxed">
          <p>
            Vince Sinnott is an electronic music composer and the founder of GODMODE SOUND.
            His work spans ambient, functional audio, and 432Hz-tuned compositions designed
            for focused listening.
          </p>
          <p>
            MIRRORS is his applied-listening project — 96 calibrated sessions built for
            focus, calm, and deep presence. Each session is composed, not generated.
          </p>
          <div className="space-y-2">
            <div className="text-xs font-mono text-[#FF0000]/50">DISCOGRAPHY</div>
            <ul className="space-y-1 text-sm">
              <li><a href="https://music.apple.com/us/artist/vince-sinnott/1501625874" target="_blank" rel="noopener noreferrer" className="text-[#FF0000]/70 hover:text-[#FF0000] underline">Codes (2025) — Apple Music</a></li>
              <li><a href="https://music.apple.com/us/artist/vince-sinnott/1501625874" target="_blank" rel="noopener noreferrer" className="text-[#FF0000]/70 hover:text-[#FF0000] underline">In Memory Of (2018) — Apple Music</a></li>
            </ul>
          </div>
        </CardContent>
      </Card>

      <Card className="sg-frame border-[#FF0000]/20">
        <CardHeader>
          <CardTitle className="text-[#FF0000]">GODMODE SOUND</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-[#ddd] text-sm leading-relaxed">
          <p>
            GODMODE SOUND is a functional audio label creating artist-curated sound experiences.
            All products are built on a 432Hz foundation and designed for intentional listening.
          </p>
          <div className="flex items-center gap-2 text-[#FF0000]/60 text-xs font-mono">
            <Mail className="w-4 h-4" />
            <a href="mailto:contact@godmodesound.com" className="hover:text-[#FF0000] underline">contact@godmodesound.com</a>
          </div>
        </CardContent>
      </Card>

      <Card className="sg-frame border-[#FF0000]/20">
        <CardHeader>
          <CardTitle className="text-[#FF0000]">Refund Policy</CardTitle>
        </CardHeader>
        <CardContent className="text-[#ddd] text-sm leading-relaxed space-y-2">
          <p>If you are unsatisfied with a purchase, contact us within 14 days at contact@godmodesound.com for a full refund.</p>
          <p className="text-xs text-[#666]">Subscription cancellations take effect at the end of the current billing period.</p>
        </CardContent>
      </Card>
    </div>
  );
}
